angular.module('resourceCenterGlobalSearchModule', ['resourceCenterGlobalSearchRouterModule']).controller('resourceCenterGlobalSearchCtrl',
    [
        '$scope',
        '$state',
        'publicToolService',
        function ($scope, $state, publicToolService) {
            initStatus();
            initData();

            /**
             * [initStatus description]
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.frameUrl = '/newmanageconfig/#/globalSearch?keyWords=' + ($state.params.keyWords || '');
                $scope.data = {
                    headInfo: {},
                };
                // $scope.page = {
                //     CURRPAGE: 1,
                //     PAGESIZE: 10,
                //     ITEMCOUNT: 0,
                //     PAGECOUNT: 1,
                // };
                // $scope.data = {
                //     previewCache: {
                //         '-1': 'fusionPreview',
                //         '3': 'newspaperPreviewCache',
                //         '2': 'websitePreview',
                //         '1': 'appPreview',
                //         '4': 'weixinPreview',
                //         '5': 'wbPreview',
                //         '15': {
                //             '串联单': 'seriesSheetPreview',
                //             '广电文稿': 'televisionPreview'
                //         },
                //         '16': {
                //             '串联单': 'broadcastSeriesSheetPreview',
                //             '广电文稿': 'broadcastPreview'
                //         }
                //     },
                //     items: [], // 返回的数据
                //     selectedArray: [], // 已经选择的渠道
                //     channels: [], // 返回的所有渠道     
                //     TOTAL: '', // 数量 
                //     channelType: {
                //         receivedoc: '已收稿库',
                //         docrecord: '稿件档案',
                //         persondoc: '个人稿库',
                //         recycledoc: '废稿箱',
                //     }  
                // };
                // // 查询指定渠道稿件的参数
                // $scope.params = {
                //     serviceid: 'mlf_hybasesearch',
                //     methodname: 'queryOneMedia',
                //     // user_account: JSON.parse(sessionStorage.getItem('ls.curUserInfo')).USERNAME,
                //     keywords: $state.params.keyWords ? $state.params.keyWords : '', // 搜索的关键词
                //     startDate: '', // 开始日期
                //     endDate: '', // 结束日期
                //     mediaType: '', // 默认是个人采写
                //     PAGESIZE: '10',
                //     PAGEINDEX: '',
                // };
            }

            /**
             * [initData description]
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                getHeaderInfo(); // 请求所有的渠道
            }

            /**
         * [getNetworkResourceConfig description] 获取网络资源模块配置
         * @return  {[type]}  [return description]
         */
            function getHeaderInfo() {
                publicToolService.getHeaderInfo($scope);
            }
            // /**
            //  * [paramsByMediaType description]
            //  *
            //  * @param   {[type]}  i  [i description] 路由添加关联稿件id信息
            //  *
            //  * @return  {[type]}     [return description]
            //  */
            // function paramsByMediaType(i) {
            //     var paramsByMediaType = {
            //         '1': 'app',
            //         '2': 'wz',
            //         // '3': '',
            //         '4': 'wx',
            //         '5': 'wb',
            //         '17': 'douyin',
            //         '18': 'baijiahao',
            //         '19': 'qiehao',
            //         '20': '',
            //     };
            //     return paramsByMediaType[i];
            // }
            
            // /**
            //  * [requestData description] 初始化数据
            //  *
            //  * @return  {[type]}  [return description]
            //  */
            // function getChannels() {
            //     var params = {
            //         serviceid: 'mlf_hybasesearch',
            //         methodname: 'queryAllMediaHitCount',
            //         keywords: $scope.params.keywords,
            //         startDate: $scope.params.startDate,
            //         endDate: $scope.params.endDate
            //     };
            //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
            //         $scope.data.channels = data.DATAS;
            //         $scope.data.TOTAL = data.TOTAL;
            //         $scope.data.selectedArray = [];
            //         // 有渠道的话 就请求具体渠道的 稿件
            //         if (data.DATAS.length > 0) {
            //             $scope.data.selectedArray.push(data.DATAS[0]);
            //             $scope.params.mediaType = data.DATAS[0].MEDIATYPE;
            //             requestData();
            //         // 没有渠道的话，直接把稿件列表置空 
            //         } else {
            //             $scope.page.ITEMCOUNT = 0;
            //             // $scope.data.TOTAL = 0;
            //             $scope.data.items = [];
            //         }
                                 
            //     });
            // }

            // /**
            //  * [requestData description]请求命中渠道的数据
            //  *
            //  * @param   {[type]}  type  [type description]渠道类型
            //  *
            //  * @return  {[type]}        [return description]
            //  */
            // function requestData(type) {
            //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then((data) => {
            //         $scope.data.items = data.DATAS;
            //         $scope.page.ITEMCOUNT = data.SUMMARYINFO.total;
            //         getRelatedInfo(data.DATAS).then((res) => {
            //             angular.forEach(data.DATAS, function(value, key) {
            //                 value.relatedInfo = res[value.METADATAID];
            //             });
            //         });
            //     });
            // }

            // /**
            // * [jumpdetailPage description]跳转细览页
            // *
            // * @param   {[type]}  item  [item description]
            // *
            // * @return  {[type]}        [return description]
            // */
            // $scope.jumpdetailPage = function (item) {
            //     var looper = item.relatedMedias ? item.relatedMedias : item.relatedInfo;
            //     var routerParams = {};
            //     angular.forEach(looper, function (value, key) {
            //         routerParams[paramsByMediaType(value.MEDIATYPE) + 'chnldocid'] = value.CHNLDOCID;
            //         routerParams[paramsByMediaType(value.MEDIATYPE) + 'metadataid'] = value.VIRTUALDOCID;
            //         routerParams[paramsByMediaType(value.MEDIATYPE) + 'articleid'] = value.VIRTUALDOCID;
            //         routerParams.paperid = value.CHANNELID;
            //         routerParams.bzmetadata = value.VIRTUALDOCID;
            //     });
            //     // 用于详细页面的上一篇 下一篇
            //     storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,CHANNELDOCID,DOCTYPEID,CHANNELID', $scope.data.previewCache[item.MEDIATYPE]);
            //     if (item.MEDIATYPE === '15' || item.MEDIATYPE === '16') {
            //         storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,CHANNELDOCID,DOCTYPEID', $scope.data.previewCache[item.MEDIATYPE][item.MEDIATYPENAME]);
            //     }
            //     if (item.MEDIATYPENAME !== '抖音') {
            //         editingCenterService.routerToPreview(item, angular.extend({ fromsearch: '1'}, routerParams));
            //     }   
            // };

            // /**
            //  * [queryByDropdown description] 时间筛选
            //  *
            //  * @return  {[type]}  [return description]
            //  */
            // $scope.queryByTime = function () {
            //     $scope.page.CURRPAGE = $scope.params.PAGEINDEX = '1';   
            //     getChannels();
            //     // requestData();
            // };

            // /**
            //  * [searchByKeywords description]
            //  *
            //  * @param   {[type]}  ev  [ev description] 关键词
            //  *
            //  * @return  {[type]}      [return description]
            //  */
            // $scope.searchByKeywords = function (ev) {
            //     if ((ev && ev.keyCode === 13) || !ev) {
            //         $scope.page.CURRPAGE = $scope.params.PAGEINDEX = '1';   
            //         getChannels(); // 请求所有的渠道
            //         // requestData(); // 请求当前渠道的数据
            //     }
            // };

            // /**
            //  * [queryByChannel description]渠道筛选
            //  *
            //  * @param   {[type]}  item  [item description]
            //  *
            //  * @return  {[type]}        [return description]
            //  */
            // $scope.queryByChannel = function (item) {  
            //     $scope.page.CURRPAGE = $scope.params.PAGEINDEX = '1';          
            //     $scope.params.mediaType = item.MEDIATYPE;
            //     $scope.data.selectedArray = [];
            //     $scope.data.selectedArray.push(item);
            //     requestData();                    
            // };

            // /**
            //  * [selectPageNum description]每页显示数据筛选
            //  *
            //  * @return  {[type]}  [return description]
            //  */
            // $scope.selectPageNum = function () {
            //     $scope.params.PAGEINDEX = '1';
            //     $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            //     requestData();
            // };

            // /**
            //   * [pageChanged description] 页码筛选
            //   *
            //   * @return  {[type]}  [return description]
            //   */
            // $scope.pageChanged = function () {
            //     $scope.params.PAGEINDEX = $scope.page.CURRPAGE;
            //     requestData();
            // };

            // /**
            //  * [getRelatedInfo description] 获取稿件关联信息,iwo渠道融合编辑
            //  *
            //  * @param   {[type]}  items  [items description]
            //  *
            //  * @return  {[type]}         [return description]
            //  */
            // function getRelatedInfo(items) {
            //     var defer = $q.defer();
            //     if (!items || items.length < 1) {
            //         defer.resolve([]);
            //     } else {
            //         let params = {
            //             serviceid: 'mlf_fusioncreate',
            //             methodname: 'queryFuseMappingsByDocIds',
            //             sourceDocIds: trsspliceString.spliceString(items, 'METADATAID', ','),
            //         };
            //         trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
            //             defer.resolve(data);
            //         });
            //     }
            //     return defer.promise;
            // }

        },

    ]);
